<template>
    <div class="col-12 nopadding">
        <div class="calendar-parallax" v-if="is_desktop_banner">
            <div class="bottom-block">
                <div class="container">
                    <div class="row clearfix">
                        <div id="web-banner">
                            <div class="banner border">
                                <div class="content fullscreen">
                                    <img class="background0 fullscreen" svg src="/static/images/web-banner-2022/TI_Membership_Campaign_2022_Web_Banner_1380x400.gif">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="banner-mobile" v-if="!is_desktop_banner">
            <div class="border banner fullscreen banner-mobile" 
                 v-bind:style="{ width: widthBanner + 'px', height: heightBanner + 'px' }">
                <img class="background0 fullscreen banner-mobile" 
                     v-bind:style="{ width: widthBanner + 'px', height: heightBanner + 'px' }"
                     src="/static/images/web-banner-2022/TI_Membership_Campaign_2022_Web_Banner_1380x400.gif">
            </div>
        </div>
    </div>
</template>

<script>
    import '@/assets/web-banner-2022/web-banner-2022.scss';

    const BannerConst = {
        bannerWidthNorm: 917,
        bannerHeightNorm: 200,
        minWidth: 1000
    };

    export default {
        name: "t-banner",
        props: {
            title: String,
            alt: String
        },
        created() {
            window.addEventListener("resize", this.resizeHandler);
            window.addEventListener("orientationchange", this.resizeHandler);
            this.resizeHandler();
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeHandler);
            window.removeEventListener("orientationchange", this.resizeHandler);
        },
        methods: {
            resizeHandler() {
                const bannerWidthNorm = BannerConst.bannerWidthNorm;
                const bannerHeightNorm = BannerConst.bannerHeightNorm;
                const minWidth = BannerConst.minWidth;
                let widthScreen = 0;
                let heightScreen = 0;
                this.widthBanner = bannerWidthNorm;
                this.heightBanner = bannerHeightNorm;

                const mobileAndTabletCheck = function () {
                    const toMatch = [
                        /Android/i,
                        /webOS/i,
                        /iPhone/i,
                        /iPad/i,
                        /iPod/i,
                        /BlackBerry/i,
                        /Windows Phone/i
                    ];
                    return toMatch.some((toMatchItem) => {
                        return navigator.userAgent.match(toMatchItem);
                    });
                };

                if (mobileAndTabletCheck()) {
                    widthScreen = window.outerWidth;
                    heightScreen = window.outerHeight;
                } else {
                    widthScreen = window.innerWidth;
                    heightScreen = window.innerHeight;
                }

                if (widthScreen < minWidth) {
                    var delta = widthScreen / bannerWidthNorm;
                    this.widthBanner = this.widthBanner * delta;
                    this.heightBanner = this.heightBanner * delta;
                    this.is_desktop_banner = false;
                }
                else {
                    this.is_desktop_banner = true;
                }
            }
        },
        data() {
            return {
                is_desktop_banner: true,
                widthBanner: BannerConst.bannerWidthNorm,
                heightBanner: BannerConst.bannerHeightNorm
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/user/race-events/race-components/web-banner-2022.vue